// TODO use/update models
import { CrudState } from "@/store/modules/crud/State";
import IService from "@/models/IService";

export class State extends CrudState {
  dataList: Array<IService> = [];
  dataItem: IService | null = null;
}
